import React from "react";
import { useT } from "@/hooks/useT";

const QUESTIONS = ["q1", "q2", "q3", "q4"];

/**
 * FAQ accordion for /verified-documents.
 *
 * Semantic: `<section>` → `<h2>` → each item is a `<details>` whose
 * `<summary>` wraps an `<h3>` (per the brief). Native `<details>`
 * disclosure handles keyboard accessibility and aria-expanded for us.
 */
export function Faq() {
  const { t } = useT("verifiedDocuments");

  return (
    <section
      className="border-t border-hairline pb-24 pt-16 md:pb-32 md:pt-20"
      data-testid="verified-faq"
    >
      <div className="mx-auto max-w-4xl px-6">
        <h2 className="font-sans text-3xl font-bold leading-tight tracking-tight sm:text-4xl">
          {t("faq.section")}
        </h2>
        <ul className="mt-8 space-y-3">
          {QUESTIONS.map((k) => (
            <li key={k}>
              <details className="group rounded-[16px] border border-hairline bg-[rgba(21,10,36,0.4)] px-6 py-5">
                <summary
                  className="flex cursor-pointer list-none items-start justify-between gap-6 text-base font-semibold text-ink-primary transition-colors duration-fast ease-out hover:text-frac-violet focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-frac-violet focus-visible:ring-offset-2 focus-visible:ring-offset-surface-base"
                  data-testid={`faq-summary-${k}`}
                >
                  <h3 className="text-lg font-semibold tracking-tight">
                    {t(`faq.${k}.question`)}
                  </h3>
                  <span
                    aria-hidden
                    className="relative mt-1 inline-block h-5 w-5 shrink-0 text-ink-secondary transition-transform duration-base ease-out group-open:rotate-45"
                  >
                    <span className="absolute left-0 top-1/2 block h-px w-5 -translate-y-1/2 bg-current" />
                    <span className="absolute left-1/2 top-0 block h-5 w-px -translate-x-1/2 bg-current" />
                  </span>
                </summary>
                <p className="mt-4 text-sm leading-relaxed text-ink-secondary">
                  {t(`faq.${k}.answer`)}
                </p>
              </details>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default Faq;
